var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"p-siteLogo",attrs:{"src":_vm.image.url,"width":_vm.image.width,"height":_vm.image.height,"alt":_vm.$t(`${_vm.portalId}.おみせのトラスト`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }